import { useGlobalStore } from "~/stores/global";

export const useBlogLocale = () => {
  const preferedLocale = useGlobalStore().siteCurrentLocale;
  if (!preferedLocale) {
    return useState("blogLocale", () => "en");
  }

  const localePrefix = preferedLocale.split("-").at(0);
  if (!localePrefix) {
    return useState("blogLocale", () => "en");
  }

  return useState("blogLocale", () => localePrefix);
};

export const useCurrentCountryData = () => {
  const { locale } = useI18n();
  const globalStore = useGlobalStore();
  const allSites = globalStore.siteAllLocales;

  const countryCode = computed(() => {
    // Extract "US" from "en-US"
    return locale.value.split("-")[1] || null;
  });

  const countryData = computed(() => {
    if (!countryCode.value) return null;
    return allSites?.[countryCode.value.toUpperCase()] || null;
  });

  return {
    countryCode,
    countryData,
  };
};
